module.exports = __webpack_public_path__ + "static/img/默认头像.9ab08cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/默认头像.png
// module id = oqhj
// module chunks = 1